import { UniqueIdFormat } from '../../../../models/unique-id-format.model';
import { FormatFieldName } from './format-field-name.enum';

export const FormatFields = {
  [FormatFieldName.BUSINESS_DATE]: UniqueIdFormat.V_SUBSET_FLD_NM_VAL_BUSINESS_DATE,
  [FormatFieldName.BUSINESS_UNIT]: UniqueIdFormat.V_SUBSET_FLD_NM_VAL_BUSINESS_UNIT,
  [FormatFieldName.SEQUENCE]: UniqueIdFormat.V_SUBSET_FLD_NM_VAL_SEQUENCE,
  '': UniqueIdFormat.SUBSET_FLD_NM_VAL
};
